import { render } from "./GeodesistCallsBlock.vue?vue&type=template&id=6310af9a&scoped=true"
import script from "./GeodesistCallsBlock.vue?vue&type=script&lang=js"
export * from "./GeodesistCallsBlock.vue?vue&type=script&lang=js"

import "./GeodesistCallsBlock.vue?vue&type=style&index=0&id=6310af9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6310af9a"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QIcon,QBtn,QTooltip});
